import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { pushModal } from '../../../../Modals/redux/actionCreators';
import { useRestrictToLoggedIn } from '../../../../utils/hooks/useRestrictToLoggedIn';
import { BiEventType, BiDataHook, ReferralType, } from '@wix/da-bi/pkg/constants';
import Button from '../../../../Button';
import { ModalType } from '../../../../Modals/redux/types';
import useLeaveACommentNotification from '../useLeaveACommentNotification';
var MobileDownloadLink = function (_a) {
    var deviation = _a.deviation, _b = _a.deviation, deviationId = _b.deviationId, _c = _b.extended, _d = _c === void 0 ? {} : _c, download = _d.download, pcp = _d.pcp;
    var t = useTranslation().t;
    var _e = useRestrictToLoggedIn(), isLoggedIn = _e.isLoggedIn, restrictToLoggedIn = _e.restrictToLoggedIn;
    var dispatch = useDispatch();
    var openMobileFreeAndPcpPopover = useCallback(function () {
        dispatch(pushModal(ModalType.MOBILE_DEVIATION_PCP, { params: { deviation: deviation } }));
    }, [dispatch, deviation]);
    var addLeaveACommentNotification = useLeaveACommentNotification(deviation);
    // if no free or premium download, render nothing
    if (!download && !pcp) {
        return null;
    }
    // if premium only or both free and premium, we open a modal
    if (pcp) {
        return (React.createElement(Button, { view: "b18", onClick: openMobileFreeAndPcpPopover }, t(download
            ? 'actionbar.mobilePcp.freeAndPremiumDownload'
            : 'actionbar.mobilePcp.premiumDownload')));
    }
    // if free only, we download directly from this button
    return (download === null || download === void 0 ? void 0 : download.url) ? (React.createElement(Button, { view: "b18", href: isLoggedIn ? download === null || download === void 0 ? void 0 : download.url : undefined, download: true, onClick: restrictToLoggedIn(ReferralType.ANON_DOWNLOAD, addLeaveACommentNotification), "data-hook": BiDataHook.DEVIATION_DOWNLOAD_BUTTON, biData: {
            evid: BiEventType.CLICK_DOWNLOAD_BUTTON,
            deviationid: deviationId,
            ispaiddownload: 0,
        } }, t('common.download'))) : null;
};
MobileDownloadLink.displayName = 'MobileDownloadLink';
export default MobileDownloadLink;
//# sourceMappingURL=MobileDownloadLink.js.map